import React, { PropTypes } from "react";
import styles from "components/documents/dropdown.scss";
import grid from "components/grid.scss";
import { categoryType, selectOptionType, vendorType } from "custom-prop-types";
import { Button } from "components/common/button";
import { Select } from "components/common/select";
import { ActiveFilterItem } from "components/documents/filters/active-filter-item";

export const CategoryDropdown = ({
  accountId,
  focusedCategory,
  isSaveCategoryLoading,
  newIncludeRules,
  onRemoveDropdownRule,
  onSaveCategory,
  onUnfocusCategory,
  onUpdateCategoryName,
  onUpdateIncludeVendors,
  rowHeight,
  vendors
}) => {
  if (focusedCategory === null) {
    return null;
  }
  const newStyle = { top: (focusedCategory.style.top) + (rowHeight * 2.5) };
  return (
    <div className={ styles.container } key={ focusedCategory.id } style={ newStyle }>
      <div className={ styles.dropdown }>
        <div className={ grid["container-fluid"] }>
          <div className={ `${styles["categories-row"]} ${grid.row}` }>
            <div className={ grid["col-md-6"] }>
              <div className={ styles["field-cell"] }>
                <div>Name</div>
                <input
                  className={ styles.fields }
                  defaultValue={ focusedCategory.name }
                  disabled={ focusedCategory.type === "system" }
                  onBlur={ (e) => onUpdateCategoryName(e.target.value) }
                  type="text"
                />
              </div>
            </div>

            <div className={ grid["col-md-6"] }>
              <div className={ styles["field-cell"] }>
                <div>Vendors</div>
                <Select
                  data={ mapVendors(vendors) }
                  onChange={ (e) => { onUpdateIncludeVendors(e); } }
                  placeholder="Add a vendor rule"
                />
              </div>

              <div className={ styles["field-cell"] }>
                <div>
                  <div>Vendor rules:</div>
                  { displayRulesMapper(focusedCategory.rules.includeVendors, newIncludeRules, onRemoveDropdownRule) }
                </div>
              </div>

              <div className={ styles["actions-container"] }>
                <Button link onClick={ () => onUnfocusCategory() }>cancel</Button>
                <Button
                  loading={ isSaveCategoryLoading }
                  onClick={ () => onSaveCategory({ accountId, focusedCategory, newIncludeRules }) }
                  primary
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

CategoryDropdown.defaultProps = {
  focusedCategory: null
};

CategoryDropdown.propTypes = {
  accountId: PropTypes.string.isRequired,
  focusedCategory: categoryType,
  isSaveCategoryLoading: PropTypes.bool.isRequired,
  newIncludeRules: PropTypes.arrayOf(selectOptionType).isRequired,
  onRemoveDropdownRule: PropTypes.func.isRequired,
  onSaveCategory: PropTypes.func.isRequired,
  onUnfocusCategory: PropTypes.func.isRequired,
  onUpdateCategoryName: PropTypes.func.isRequired,
  onUpdateIncludeVendors: PropTypes.func.isRequired,
  rowHeight: PropTypes.number.isRequired,
  vendors: PropTypes.arrayOf(vendorType).isRequired
};

const mapVendors = (vendors) => vendors.map(vendor => ({ key: vendor.name, name: vendor.name }));

const displayRulesMapper = (rules, newRules, onRemoveDropdownRule) => {
  if (rules.length === 0 && newRules.length === 0) {
    return <h3>No vendor rules</h3>;
  }
  const existingRender = rules.map((rule) => renderExistingRule(rule, onRemoveDropdownRule));
  const newRender = newRules.map((rule) => renderNewRule(rule, onRemoveDropdownRule));
  return [existingRender, newRender];
};

const renderExistingRule = (rule, onRemoveDropdownRule) => (
  <span key={ `${rule.vendorName}` }>
    <ActiveFilterItem name={ rule.vendorName } onRemove={ () => { onRemoveDropdownRule(rule); } } />
  </span>
);

const renderNewRule = (rule, onRemoveDropdownRule) => (
  <span key={ `${rule.name}` }>
    <ActiveFilterItem name={ rule.name } onRemove={ () => { onRemoveDropdownRule(rule, true); } } />
  </span>
);



// WEBPACK FOOTER //
// ./src/js/components/manage-categories/category-dropdown.jsx